var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"help",attrs:{"to":_vm.route}},[_c('v-icon',{staticClass:"help-icon",attrs:{"size":"21"}},[_vm._v(" mdi-help-circle-outline ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }